import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>TEJ Solutions Hub - Software Development, Digital Marketing & Business Financing</title>
        <meta name="description" content="Full-service software development company. Web development, mobile apps, digital marketing, cloud infrastructure, SMS campaigns, and business financing referrals." />
      </Helmet>

      {/* Hero Section */}
      <div style={{ 
        background: `
          linear-gradient(135deg, rgba(124, 58, 237, 0.85) 0%, rgba(167, 139, 250, 0.85) 100%),
          url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: 'white', 
        padding: '10rem 2rem 6rem', 
        textAlign: 'center', 
        position: 'relative', 
        overflow: 'hidden'
      }}>
        <div style={{ position: 'absolute', top: '-50%', right: '-10%', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)', borderRadius: '50%', animation: 'float 6s ease-in-out infinite' }}></div>
        <div style={{ position: 'absolute', bottom: '-30%', left: '-5%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(251,191,36,0.15) 0%, transparent 70%)', borderRadius: '50%', animation: 'float 8s ease-in-out infinite reverse' }}></div>
        
        <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.25)', padding: '0.5rem 1.5rem', borderRadius: '50px', marginBottom: '2rem', border: '2px solid rgba(255,255,255,0.4)', backdropFilter: 'blur(10px)' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: '700', textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>✓ A2P Registered | TCPA Compliant | EIN: 86-3326707</span>
          </div>
          
          <h1 style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '1.5rem', lineHeight: '1.2', textShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
            Transform Your Business with Technology
          </h1>
          <p style={{ fontSize: '1.5rem', marginBottom: '2rem', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
            Full-Service Software Development, Digital Marketing & Business Financing
          </p>
          <p style={{ fontSize: '1.1rem', marginBottom: '3rem', maxWidth: '700px', margin: '0 auto 3rem', textShadow: '0 2px 6px rgba(0,0,0,0.3)' }}>
            Web Development | Mobile Apps | Digital Marketing | Cloud Infrastructure | SMS Campaigns | Business Financing
          </p>
          
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '3rem' }}>
            <Link to="/contact" style={{
              display: 'inline-block',
              background: '#fbbf24',
              color: '#1f2937',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 8px 24px rgba(251, 191, 36, 0.5)',
              transition: 'all 0.3s ease',
              border: '2px solid #fbbf24'
            }}>
              Start Your Project →
            </Link>
            <Link to="/services" style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.25)',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              border: '3px solid white',
              transition: 'all 0.3s ease',
              backdropFilter: 'blur(10px)',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              View Services
            </Link>
          </div>

          {/* Stats */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '2rem', maxWidth: '800px', margin: '0 auto', paddingTop: '2rem' }}>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>5+</div>
              <div style={{ fontSize: '0.95rem' }}>Years Experience</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>100+</div>
              <div style={{ fontSize: '0.95rem' }}>Projects Delivered</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>50+</div>
              <div style={{ fontSize: '0.95rem' }}>Happy Clients</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>24/7</div>
              <div style={{ fontSize: '0.95rem' }}>Support</div>
            </div>
          </div>
        </div>
      </div>

      {/* Business Verification */}
      <div style={{ 
        background: `
          linear-gradient(rgba(249, 250, 251, 0.88), rgba(249, 250, 251, 0.88)),
          url('https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '3rem 2rem', 
        borderBottom: '1px solid #e5e7eb'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            <div style={{ textAlign: 'center', padding: '1.5rem', background: 'white', borderRadius: '12px', border: '2px solid #7c3aed', boxShadow: '0 4px 12px rgba(124, 58, 237, 0.1)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>🏢</div>
              <div style={{ fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Verified Business</div>
              <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>TEJ SUSTAINABILITY GROUP, INC.</div>
              <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '0.25rem' }}>EIN: 86-3326707</div>
            </div>
            <div style={{ textAlign: 'center', padding: '1.5rem', background: 'white', borderRadius: '12px', border: '2px solid #7c3aed', boxShadow: '0 4px 12px rgba(124, 58, 237, 0.1)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>📍</div>
              <div style={{ fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Physical Address</div>
              <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>4273 Savannah Trce</div>
              <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '0.25rem' }}>Atlanta, GA 30349</div>
            </div>
            <div style={{ textAlign: 'center', padding: '1.5rem', background: 'white', borderRadius: '12px', border: '2px solid #7c3aed', boxShadow: '0 4px 12px rgba(124, 58, 237, 0.1)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>👤</div>
              <div style={{ fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>Founder</div>
              <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>Zebedee McLaurin</div>
              <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '0.25rem' }}>Industry Expert</div>
            </div>
            <div style={{ textAlign: 'center', padding: '1.5rem', background: 'white', borderRadius: '12px', border: '2px solid #7c3aed', boxShadow: '0 4px 12px rgba(124, 58, 237, 0.1)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✓</div>
              <div style={{ fontWeight: '700', color: '#1f2937', marginBottom: '0.5rem' }}>A2P Registered</div>
              <div style={{ fontSize: '0.9rem', color: '#6b7280' }}>Campaign Approved</div>
              <div style={{ fontSize: '0.85rem', color: '#9ca3af', marginTop: '0.25rem' }}>Carrier Verified</div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div style={{ 
        padding: '6rem 2rem', 
        background: `
          linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)),
          url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', textAlign: 'center', marginBottom: '1rem', color: '#1f2937' }}>
            Our Services
          </h2>
          <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#6b7280', marginBottom: '4rem', maxWidth: '700px', margin: '0 auto 4rem' }}>
            Comprehensive technology solutions to grow your business
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            {[
              { icon: '💻', title: 'Web Development', desc: 'Custom websites, e-commerce platforms, and web applications built with modern technologies.' },
              { icon: '📱', title: 'Mobile App Development', desc: 'iOS and Android apps with seamless user experiences and powerful functionality.' },
              { icon: '🎯', title: 'Digital Marketing', desc: 'SEO, social media marketing, content strategy, and PPC campaigns that drive results.' },
              { icon: '📧', title: 'Email Marketing', desc: 'Automated email campaigns, list management, and analytics for better engagement.' },
              { icon: '☁️', title: 'Cloud Infrastructure', desc: 'AWS, Azure, GCP solutions with DevOps, security, and scalability.' },
              { icon: '💬', title: 'SMS Marketing', desc: 'A2P 10DLC compliant SMS communication for customer engagement with real-time delivery and analytics.' },
              { icon: '📊', title: 'Digital Campaigns', desc: 'Multi-channel campaign strategy, execution, and performance optimization.' },
              { icon: '📲', title: 'SMS Campaigns', desc: 'TCPA compliant SMS messaging to communicate with customers, with proper consent and opt-out management.' },
              { icon: '💰', title: 'Business Financing', desc: 'Connect businesses with financing options from $50K to $5M+ for growth and working capital needs.' }
            ].map((service, idx) => (
              <div key={idx} style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease',
                border: '2px solid #e5e7eb',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '100px', height: '100px', background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', opacity: '0.05', borderRadius: '50%' }}></div>
                <div style={{ fontSize: '3.5rem', marginBottom: '1.5rem', position: 'relative' }}>{service.icon}</div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem', color: '#7c3aed', position: 'relative' }}>
                  {service.title}
                </h3>
                <p style={{ color: '#6b7280', lineHeight: '1.8', position: 'relative' }}>{service.desc}</p>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/services" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1.25rem 3rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: '700',
              fontSize: '1.1rem',
              boxShadow: '0 8px 24px rgba(124, 58, 237, 0.3)'
            }}>
              View All Services →
            </Link>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <div style={{ padding: '6rem 2rem', background: 'white' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', textAlign: 'center', marginBottom: '4rem', color: '#1f2937' }}>
            Why Choose TEJ Solutions Hub?
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚡</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>Fast Delivery</h3>
              <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Quick turnaround times without compromising quality</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎯</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>Expert Team</h3>
              <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Experienced developers and marketers</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>💰</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>Competitive Pricing</h3>
              <p style={{ color: '#6b7280', lineHeight: '1.8' }}>Affordable solutions for businesses of all sizes</p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔒</div>
              <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>Fully Compliant</h3>
              <p style={{ color: '#6b7280', lineHeight: '1.8' }}>TCPA, CTIA, and A2P 10DLC compliant</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{ 
        background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', 
        padding: '5rem 2rem', 
        textAlign: 'center', 
        color: 'white' 
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem' }}>Ready to Transform Your Business?</h2>
          <p style={{ fontSize: '1.1rem', marginBottom: '2rem', opacity: '0.95' }}>
            Let's discuss your project and create something amazing together
          </p>
          <Link to="/contact" style={{
            display: 'inline-block',
            background: '#fbbf24',
            color: '#1f2937',
            padding: '1.25rem 3rem',
            borderRadius: '12px',
            textDecoration: 'none',
            fontWeight: '700',
            fontSize: '1.1rem',
            boxShadow: '0 8px 24px rgba(251, 191, 36, 0.4)'
          }}>
            Get Started Today →
          </Link>
        </div>
      </div>

      {/* Messaging Disclosure */}
      <div style={{ background: '#fef3c7', padding: '2rem', borderTop: '2px solid #fbbf24' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '1rem', color: '#92400e', fontWeight: '600', marginBottom: '0.5rem' }}>
            SMS/Email Communication Notice
          </p>
          <p style={{ fontSize: '0.95rem', color: '#78350f', lineHeight: '1.6' }}>
            TEJ Solutions Hub uses Twilio to send SMS and email communications to our customers and clients. All messages are sent with proper consent in compliance with TCPA, CTIA, and carrier regulations.
          </p>
        </div>
      </div>
    </>
  );
}
